import { render, staticRenderFns } from "./BrbFormWrapper.vue?vue&type=template&id=53b8789b&"
import script from "./BrbFormWrapper.vue?vue&type=script&lang=js&"
export * from "./BrbFormWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/matin/baarbaanet/frontend/admin-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53b8789b')) {
      api.createRecord('53b8789b', component.options)
    } else {
      api.reload('53b8789b', component.options)
    }
    module.hot.accept("./BrbFormWrapper.vue?vue&type=template&id=53b8789b&", function () {
      api.rerender('53b8789b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/brb-components/BrbFormWrapper.vue"
export default component.exports